import { useState } from "react";

type Props = {
  open: boolean;
  onClose: () => void;
  title: string;
};

const options = [
  { key: "weibo", icon: "ri-weibo-fill", label: "微博", color: "bg-secondary-200 text-secondary-900" },
  { key: "wechat", icon: "ri-wechat-fill", label: "微信", color: "bg-accent-100 text-accent-800" },
  { key: "link", icon: "ri-link", label: "复制链接", color: "bg-background-200 text-foreground-700" },
];

export default function ShareModal({ open, onClose, title }: Props) {
  const [toast, setToast] = useState("");

  if (!open) return null;

  const handle = async (key: string) => {
    if (key === "link") {
      try {
        await navigator.clipboard.writeText(window.location.href);
        setToast("链接已复制到剪贴板");
      } catch {
        setToast("复制失败，请手动复制地址");
      }
    } else {
      setToast(`已打开${key === "weibo" ? "微博" : "微信"}分享面板`);
    }
    setTimeout(() => setToast(""), 2200);
  };

  return (
    <div className="fixed inset-0 z-[60] flex items-center justify-center px-4">
      <div className="absolute inset-0 bg-primary-950/60" onClick={onClose}></div>
      <div className="relative w-full max-w-sm rounded-lg bg-background-50 border border-background-200 p-6 animate-fade-up">
        <div className="flex items-start justify-between gap-3">
          <div>
            <h3 className="font-heading text-lg font-bold text-foreground-950">分享这部作品</h3>
            <p className="mt-1 text-xs text-foreground-500 line-clamp-1">{title}</p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="w-8 h-8 flex items-center justify-center rounded-md text-foreground-500 hover:bg-background-100 cursor-pointer"
            aria-label="关闭"
          >
            <i className="ri-close-line text-xl"></i>
          </button>
        </div>

        <div className="mt-5 grid grid-cols-3 gap-3">
          {options.map((o) => (
            <button
              key={o.key}
              type="button"
              onClick={() => handle(o.key)}
              className="flex flex-col items-center gap-2 cursor-pointer group"
            >
              <span className={`w-12 h-12 flex items-center justify-center rounded-full ${o.color} group-hover:opacity-90 transition-opacity`}>
                <i className={`${o.icon} text-xl`}></i>
              </span>
              <span className="text-xs text-foreground-600">{o.label}</span>
            </button>
          ))}
        </div>

        {toast && (
          <div className="mt-5 rounded-md bg-primary-500 text-background-50 text-sm text-center py-2 animate-fade-in">
            {toast}
          </div>
        )}
      </div>
    </div>
  );
}